import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';
import id from 'date-fns/locale/id/index';

export const FETCH_INVOICES_REQUEST = 'FETCH_INVOICES_REQUEST';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_ERROR = 'FETCH_INVOICES_ERROR';

export const GET_INVOICE_DETAIL_REQUEST = 'GET_INVOICE_DETAIL_REQUEST';
export const GET_INVOICE_DETAIL_SUCCESS = 'GET_INVOICE_DETAIL_SUCCESS';
export const GET_INVOICE_DETAIL_ERROR = 'GET_INVOICE_DETAIL_ERROR';

export const CREATE_INVOICE_REQUEST = 'CREATE_INVOICE_REQUEST';
export const CREATE_INVOICE_SUCCESS = 'CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICE_ERROR = 'CREATE_INVOICE_ERROR';

export const UPDATE_INVOICE_REQUEST = 'UPDATE_INVOICE_REQUEST';
export const UPDATE_INVOICE_SUCCESS = 'UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_ERROR = 'UPDATE_INVOICE_ERROR';

export const DELETE_INVOICE_REQUEST = 'DELETE_INVOICE_REQUEST';
export const DELETE_INVOICE_SUCCESS = 'DELETE_INVOICE_SUCCESS';
export const DELETE_INVOICE_ERROR = 'DELETE_INVOICE_ERROR';

export const COMPLETE_INVOICE_REQUEST = 'COMPLETE_INVOICE_REQUEST';
export const COMPLETE_INVOICE_SUCCESS = 'COMPLETE_INVOICE_SUCCESS';
export const COMPLETE_INVOICE_ERROR = 'COMPLETE_INVOICE_ERROR';

export const GENERATE_INVOICE_PDF_REQUEST = 'GENERATE_INVOICE_PDF_REQUEST';
export const GENERATE_INVOICE_PDF_SUCCESS = 'GENERATE_INVOICE_PDF_SUCCESS';
export const GENERATE_INVOICE_PDF_ERROR = 'GENERATE_INVOICE_PDF_ERROR';

export const GENERATE_SPLIT_INVOICE_PDF_REQUEST = 'GENERATE_INVOICE_PDF_REQUEST';
export const GENERATE_SPLIT_INVOICE_PDF_SUCCESS = 'GENERATE_SPLIT_INVOICE_PDF_SUCCESS';

export const SEND_CUSTOMER_EMAIL_REQUEST = 'SEND_CUSTOMER_EMAIL_REQUEST';
export const SEND_CUSTOMER_EMAIL_SUCCESS = 'SEND_CUSTOMER_EMAIL_SUCCESS';
export const SEND_CUSTOMER_EMAIL_ERROR = 'SEND_CUSTOMER_EMAIL_ERROR';

export const CREATE_INVOICECANCELLED_REQUEST = 'CREATE_INVOICECANCELLED_REQUEST';
export const CREATE_INVOICECANCELLED_SUCCESS = 'CREATE_INVOICECANCELLED_SUCCESS';
export const CREATE_INVOICECANCELLED_ERROR = 'CREATE_INVOICECANCELLED_ERROR';

export const FETCH_INVOICECANCELLED_REQUEST = 'FETCH_INVOICECANCELLED_REQUEST';
export const FETCH_INVOICECANCELLED_SUCCESS = 'FETCH_INVOICECANCELLED_SUCCESS';
export const FETCH_INVOICECANCELLED_ERROR = 'FETCH_INVOICECANCELLED_ERROR';

export const GET_INVOICE_CANCELLED_DETAIL_REQUEST = 'GET_INVOICE_CANCELLED_DETAIL_REQUEST';
export const GET_INVOICE_CANCELLED_DETAIL_SUCCESS = 'GET_INVOICE_CANCELLED_DETAIL_SUCCESS';
export const GET_INVOICE_CANCELLED_DETAIL_ERROR = 'GET_INVOICE_CANCELLED_DETAIL_ERROR';

export const UPDATE_INVOICE_CANCELLED_REQUEST = 'UPDATE_INVOICE_CANCELLED_REQUEST';
export const UPDATE_INVOICE_CANCELLED_SUCCESS = 'UPDATE_INVOICE_CANCELLED_SUCCESS';
export const UPDATE_INVOICE_CANCELLED_ERROR = 'UPDATE_INVOICE_CANCELLED_ERROR';

export const DELETE_INVOICE_CANCELLED_REQUEST = 'DELETE_INVOICE_CANCELLED_REQUEST';
export const DELETE_INVOICE_CANCELLED_SUCCESS = 'DELETE_INVOICE_CANCELLED_SUCCESS';
export const DELETE_INVOICE_CANCELLED_ERROR = 'DELETE_INVOICE_CANCELLED_ERROR';

export const COMPLETE_INVOICE_CANCELLED_REQUEST = 'COMPLETE_INVOICE_CANCELLED_REQUEST';
export const COMPLETE_INVOICE_CANCELLED_SUCCESS = 'COMPLETE_INVOICE_CANCELLED_SUCCESS';
export const COMPLETE_INVOICE_CANCELLED_ERROR = 'COMPLETE_INVOICE_CANCELLED_ERROR';

export const EXPORT_EXCEL_REQUEST = 'EXPORT_EXCEL_REQUEST';
export const EXPORT_EXCEL_SUCCESS = 'EXPORT_EXCEL_SUCCESS';
export const EXPORT_EXCEL_ERROR = 'EXPORT_EXCEL_ERROR';

export const createInvoiceCancelled = (data) => dispatch => {
  console.log(data);
  return Promise.resolve(dispatch).then(() =>
    dispatch({
      types: [CREATE_INVOICECANCELLED_REQUEST, CREATE_INVOICECANCELLED_SUCCESS, CREATE_INVOICECANCELLED_ERROR],
      callAPI: () => ApiClient.post('payment/InvoiceCancelled', data),
      payload: { data },
    }),
  );
};

export const fetchInvoiceCancelled = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_INVOICECANCELLED_REQUEST, FETCH_INVOICECANCELLED_SUCCESS, FETCH_INVOICECANCELLED_ERROR],
      callAPI: () => ApiClient.post('payment/InvoiceCancelled/Search', data),
      payload: { data },
    }),
  );
};

export const getInvoiceCancelledDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [GET_INVOICE_CANCELLED_DETAIL_REQUEST, GET_INVOICE_CANCELLED_DETAIL_SUCCESS, GET_INVOICE_CANCELLED_DETAIL_ERROR],
      callAPI: () => ApiClient.get(`payment/InvoiceCancelled/GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const updateInvoiceCancelled = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [UPDATE_INVOICE_CANCELLED_REQUEST, UPDATE_INVOICE_CANCELLED_SUCCESS, UPDATE_INVOICE_CANCELLED_ERROR],
      callAPI: () => ApiClient.put(`payment/InvoiceCancelled/${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const deleteInvoiceCancelled = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_INVOICE_CANCELLED_REQUEST, DELETE_INVOICE_CANCELLED_SUCCESS, DELETE_INVOICE_CANCELLED_ERROR],
      callAPI: () => ApiClient.delete(`payment/InvoiceCancelled/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const completeInvoiceCancelled = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [COMPLETE_INVOICE_CANCELLED_REQUEST, COMPLETE_INVOICE_CANCELLED_SUCCESS, COMPLETE_INVOICE_CANCELLED_ERROR],
      callAPI: () => ApiClient.put(`payment/InvoiceCancelled/Complete/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const fetchInvoices = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_INVOICES_REQUEST, FETCH_INVOICES_SUCCESS, FETCH_INVOICES_ERROR],
      callAPI: () => ApiClient.post('payment/Invoices/Search', data),
      payload: { data },
    }),
  );
};

export const getInvoiceDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [GET_INVOICE_DETAIL_REQUEST, GET_INVOICE_DETAIL_SUCCESS, GET_INVOICE_DETAIL_ERROR],
      callAPI: () => ApiClient.get(`payment/Invoices/GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const createInvoice = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [CREATE_INVOICE_REQUEST, CREATE_INVOICE_SUCCESS, CREATE_INVOICE_ERROR],
      callAPI: () => ApiClient.post('payment/Invoices', data),
      payload: { data, formId },
    }),
  );
};

export const updateInvoice = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [UPDATE_INVOICE_REQUEST, UPDATE_INVOICE_SUCCESS, UPDATE_INVOICE_ERROR],
      callAPI: () => ApiClient.put(`payment/Invoices/${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const deleteInvoice = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_INVOICE_REQUEST, DELETE_INVOICE_SUCCESS, DELETE_INVOICE_ERROR],
      callAPI: () => ApiClient.delete(`payment/Invoices/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const completeInvoice = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [COMPLETE_INVOICE_REQUEST, COMPLETE_INVOICE_SUCCESS, COMPLETE_INVOICE_ERROR],
      callAPI: () => ApiClient.put(`payment/Invoices/Complete/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const generateInvoicePdf = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [GENERATE_INVOICE_PDF_REQUEST, GENERATE_INVOICE_PDF_SUCCESS, GENERATE_INVOICE_PDF_ERROR],
      callAPI: () => ApiClient.post(`payment/Invoices/CreatePDF/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const generateBulkInvoicePdf = (startDate, endDate, userId) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GENERATE_INVOICE_PDF_REQUEST,
        GENERATE_INVOICE_PDF_SUCCESS,
        GENERATE_INVOICE_PDF_ERROR
      ],
      callAPI: () => ApiClient.post(`admin/InvoiceConversion/ConvertInvoices/${startDate}/${endDate}/${userId}`),
      payload: { data: { startDate, endDate } },
    }),
  );
};

export const generateSplitBulkInvoicePdf = (startDate, endDate, userId) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GENERATE_SPLIT_INVOICE_PDF_REQUEST,
        GENERATE_SPLIT_INVOICE_PDF_SUCCESS,
        GENERATE_INVOICE_PDF_ERROR
      ],
      callAPI: () => ApiClient.post(`admin/InvoiceConversion/ConvertSplitBulkInvoices/${startDate}/${endDate}/${userId}`),
      payload: { data: { startDate, endDate } },
    }),
  );
};

export const generateReceiptPdf = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [GENERATE_INVOICE_PDF_REQUEST, GENERATE_INVOICE_PDF_SUCCESS, GENERATE_INVOICE_PDF_ERROR],
      callAPI: () => ApiClient.post(`payment/Invoices/CreateReceiptPDF/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const exportExcel = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [EXPORT_EXCEL_REQUEST, EXPORT_EXCEL_SUCCESS, EXPORT_EXCEL_ERROR],
      callAPI: () => ApiClient.post('payment/Invoices/ExportExcel', data, {
        responseType: 'blob'
      }),
      payload: { data }
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case GET_INVOICE_CANCELLED_DETAIL_REQUEST:
    case DELETE_INVOICE_CANCELLED_REQUEST:
    case COMPLETE_INVOICE_CANCELLED_REQUEST:
    case UPDATE_INVOICE_CANCELLED_REQUEST:
    case FETCH_INVOICES_REQUEST:
    case GET_INVOICE_DETAIL_REQUEST:
    case CREATE_INVOICE_REQUEST:
    case UPDATE_INVOICE_REQUEST:
    case FETCH_INVOICECANCELLED_REQUEST:
    case DELETE_INVOICE_REQUEST:
    case CREATE_INVOICECANCELLED_REQUEST:
    case COMPLETE_INVOICE_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_INVOICES_SUCCESS:
    case FETCH_INVOICECANCELLED_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case GET_INVOICE_CANCELLED_DETAIL_SUCCESS:
    case GET_INVOICE_DETAIL_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          item: response.data.data,
        },
        response,
        successMessage,
      };

    case UPDATE_INVOICE_CANCELLED_SUCCESS:
    case DELETE_INVOICE_CANCELLED_SUCCESS:
    case COMPLETE_INVOICE_CANCELLED_SUCCESS:
    case CREATE_INVOICE_SUCCESS:
    case UPDATE_INVOICE_SUCCESS:
    case DELETE_INVOICE_SUCCESS:
    case CREATE_INVOICECANCELLED_SUCCESS:
    case COMPLETE_INVOICE_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };

    case UPDATE_INVOICE_CANCELLED_ERROR:
    case DELETE_INVOICE_CANCELLED_ERROR:
    case COMPLETE_INVOICE_CANCELLED_ERROR:
    case FETCH_INVOICES_ERROR:
    case GET_INVOICE_DETAIL_ERROR:
    case CREATE_INVOICE_ERROR:
    case FETCH_INVOICECANCELLED_ERROR:
    case UPDATE_INVOICE_ERROR:
    case DELETE_INVOICE_ERROR:
    case CREATE_INVOICECANCELLED_ERROR:
    case COMPLETE_INVOICE_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
